angular.module("app.modalControllers").controller("ConfirmModalController", [
    '$scope',
    '$uibModalInstance',
    'text',
    function ($scope, $modalInstance, text) {
        $scope.text = text;

        $scope.ok = function () {
            $modalInstance.close();
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
]);